import { CheckCircleOutlined, TeamOutlined } from "@ant-design/icons";
import { Button, Dropdown, Tag } from "antd";
import React from "react";

export const TeamSelector = ({
	current,
	teams,
	filterBy,
	filteredBy,
	resettable = false,
	...props
}) => {
	const onClick = ({ key }) => {
		filterBy(key);
	};

	const items =
		teams && Array.isArray(teams) && teams.length > 0
			? [
					...teams?.map((team) => {
						return {
							key: team._id,
							label: (
								<div
									onClick={() => filterBy(team._id)}
									style={{ display: "flex", justifyContent: "space-between" }}>
									<div>
										{team.name}{" "}
										{team._id === current?._id ? (
											<Tag style={{ marginLeft: 4 }} color="green">
												Aktif
											</Tag>
										) : (
											<Tag style={{ marginLeft: 4, visibility: "hidden" }} color="green">
												Aktif
											</Tag>
										)}
									</div>
									{team._id === filteredBy.key && <CheckCircleOutlined />}
								</div>
							),
						};
					}),
			  ]
			: [];

	return (
		<div {...props}>
			<Dropdown
				className="filter"
				trigger={["click"]}
				menu={{
					items: items,
					onClick: onClick,
				}}>
				<Button
					type={filteredBy.value !== "" ? "primary" : "default"}
					icon={<TeamOutlined />}
					className="ant-dropdown-link btn-filter">
					<span className="btn-filter-text">
						{filteredBy.value !== "" ? `: ${filteredBy.value}` : "Tidak Ada Yg Dipilih"}
					</span>
				</Button>
			</Dropdown>
		</div>
	);
};
